<template lang="pug">
  div
    e-input-wrapper(
      v-for="(item, index) in items"
      :ctx="morphedCtx(item)"
      :item="item"
      :dynamic="_.get(item.attrs, 'dynamic', false)"
      :value="fieldVal(item)"
      :key="[item.model, '-', index].join('')"
      @input="$emit(['update:', item.model].join(''), $event)"
    )
</template>

<script>
import contexts from '~/mixins/props/contexts'
import ctx from '~/mixins/props/ctx'
import EInputDynamic from '~/components/elements/inputs/e-input-dynamic'
import TOrmLabel from '~/components/templates/orm/_includes/t-orm-label'
import EInputWrapper from '~/components/elements/inputs/e-input-wrapper'

export default {
  components: {
    EInputDynamic,
    TOrmLabel,
    EInputWrapper
  },
  mixins: [ctx, contexts],
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    currentDynamicField: null
  }),
  methods: {
    morphedCtx(item) {
      return {
        field: item,
        attrs: this.$attrs,
        fields: this.items,
        context: this.context,
        route: this.$route,
        $i18n: this.$i18n,
        ...this.ctx
      }
    },
    inContext(item) {
      if (process.env.NODE_ENV === 'development' && Number.isFinite(item.context)) {
        alert('Please replace previous context based on integer on new array representation.')
        // eslint-disable-next-line no-console
        console.error(item)
      }

      return typeof item.context === 'undefined' || item.context.includes(this.context)
    },
    fieldVal(item) {
      return this._.isFunction(item.fieldVal)
        ? item.fieldVal(this.morphedCtx(item))
        : this._.get(this.$attrs, item.model)
    },
    scopedval(reactive, item) {
      return this._.get(reactive, item.model)
    },
    fieldsValues(item) {
      return this._.pick(this.$attrs, item.models)
    },
    callListeners(listeners, item, value) {
      listeners.input(value, item)
    },
    fieldCols(field) {
      if (field.component === 'v-checkbox') {
        return { cols: 'auto' }
      }
      return field.cols || (field.label ? { cols: 12, md: 7, lg: 7, xl: 8 } : { cols: 12 })
    },
    rendererFieldCols(field) {
      const fieldConfig = field.renderer.attrs.config.prototype

      if (fieldConfig.component === 'v-checkbox') {
        return { cols: 'auto' }
      }
      return fieldConfig.label ? { cols: 12, md: 8, lg: 7, xl: 8 } : { cols: 12 }
    }
  }
}
</script>

<style scoped lang="scss">
//
</style>
